import useAPI from '@/hooks/useAPI';
import TagsRepository from '@/repositories/TagsRepository';

const usePersonTags = ({ enabled = true, personId }: { enabled?: boolean; personId: string }) => {
  const tagsRepository = TagsRepository();

  return useAPI({
    enabled,
    queryKey: ['personTags', personId],
    queryFn: async () => {
      return await tagsRepository.loadTags({ contentType: 'people', id: personId });
    }
  });
};

export default usePersonTags;
